import { LegalDocumentLayout } from '../components/LegalDocumentLayout';
import { COMPLAINTS_PROVIDER } from '../data/reclamaciones';
import { CONTACT } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

export function TermsPage() {
  useDocumentMeta({
    title: 'Términos y condiciones | Corporación Indemniza',
    description: 'Condiciones preliminares de uso del sitio web de Corporación Indemniza.',
    canonicalPath: '/terminos',
    robots: 'noindex,nofollow',
  });

  return (
    <LegalDocumentLayout
      eyebrow="Uso del sitio web"
      title="Términos y condiciones"
      intro="Condiciones preliminares aplicables al uso informativo y a los canales de contacto disponibles en indemniza.pe."
    >
      <section>
        <h2>1. Identificación</h2>
        <p>
          Este sitio corresponde a {COMPLAINTS_PROVIDER.nombreComercial}, nombre comercial de {COMPLAINTS_PROVIDER.razonSocial},
          RUC {COMPLAINTS_PROVIDER.ruc}, con domicilio en {COMPLAINTS_PROVIDER.direccion}.
        </p>
      </section>

      <section>
        <h2>2. Finalidad del sitio</h2>
        <p>
          indemniza.pe presenta información institucional, áreas de atención, datos de contacto y canales para que una persona
          pueda realizar un primer acercamiento con Corporación Indemniza. El sitio también incorpora un Libro de Reclamaciones electrónico.
        </p>
      </section>

      <section>
        <h2>3. Información y contacto inicial</h2>
        <p>
          La información publicada en el sitio es de carácter general. Navegar por la web, realizar una llamada, abrir WhatsApp
          o enviar un mensaje inicial no implica por sí solo la contratación de un servicio profesional ni garantiza un resultado,
          una indemnización o un monto determinado.
        </p>
        <p>
          Cuando un caso requiera una evaluación detallada, reunión u otro servicio profesional, las condiciones aplicables deben
          ser informadas y acordadas por separado con la persona interesada.
        </p>
      </section>

      <section>
        <h2>4. Información proporcionada por el usuario</h2>
        <p>
          La persona usuaria es responsable de procurar que la información que voluntariamente remite mediante los canales de
          contacto o el Libro de Reclamaciones sea correcta y pertinente para la finalidad de su comunicación. No es necesario
          incluir datos clínicos, documentos u otra información sensible que no resulte necesaria para un primer contacto.
        </p>
      </section>

      <section>
        <h2>5. Servicios y enlaces de terceros</h2>
        <p>
          El sitio contiene enlaces o integraciones con servicios externos, entre ellos WhatsApp, Google Maps y redes sociales.
          Al utilizar esos servicios se aplican también las condiciones y políticas de sus respectivos proveedores.
        </p>
      </section>

      <section>
        <h2>6. Privacidad y Libro de Reclamaciones</h2>
        <p>
          El tratamiento de datos personales asociado a los canales digitales debe revisarse junto con la{' '}
          <a href="/politica-de-privacidad">Política de privacidad</a>. Los reclamos y quejas de consumo pueden presentarse en el{' '}
          <a href="/libro-de-reclamaciones">Libro de Reclamaciones</a> electrónico del sitio.
        </p>
      </section>

      <section className="legal-pending-section">
        <h2>7. Puntos pendientes de validación legal</h2>
        <p>
          Antes de publicar estos términos como versión definitiva debe validarse si Corporación Indemniza desea incorporar
          disposiciones adicionales sobre propiedad intelectual, responsabilidades, disponibilidad del sitio, legislación aplicable,
          mecanismos de solución de controversias y procedimiento formal para cambios de estas condiciones.
        </p>
      </section>

      <section>
        <h2>8. Contacto</h2>
        <p>
          Para consultas relacionadas con el sitio se encuentra publicado el correo{' '}
          <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a> y el teléfono{' '}
          <a href={`tel:+${CONTACT.phoneInternational}`}>{CONTACT.phoneDisplay}</a>.
        </p>
      </section>
    </LegalDocumentLayout>
  );
}
